import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { pathname } from '../../utils';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  text: {
    display: 'flex',
    alignSelf: 'center',
    maxWidth: 800,
    textAlign: 'center',
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(0.5),
  },
}));

export default function Disclaimer() {
  const classes = useStyles();

  const text = `If you have made requests to any of your Active Lines or Remittances, the information below may no longer be current. For the most up-to-date funds delivery information, see the ${pathname.remittance.label}.`;
  return (
    <Typography variant="subtitle2" className={classes.text}>
      {text}
    </Typography>
  );
}
